/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import { useProfileDetailsStyles } from './profile-details.styles'
import { components } from '@plandi/common/src/generated'
import { useLocale, useTranslation } from '@plandi/common'

type ProfilePublicationsProps = {
  type: string | string[] | undefined
  user?: components['schemas']['UserResource']
  profileFreelancer?: components['schemas']['ProfileSpecialistMeResource']
  profileCompany?: components['schemas']['ProfileCompanyMeResource']
  profileFactory?: components['schemas']['ProfileFactoryMeResource']
}

export const ProfilePublications: FC<ProfilePublicationsProps> = ({
  type,
  user,
  profileFreelancer,
  profileCompany,
  profileFactory
}) => {
  const classes = useProfileDetailsStyles()
  const { data: translation } = useTranslation()
  const locale = useLocale()

  const publications: any =
    type === 'user'
      ? user?.publications
      : type === 'freelancer'
      ? profileFreelancer?.publications
      : type === 'company'
      ? profileCompany?.publications
      : profileFactory?.publications

  const renderPublications = () => {
    return type === 'factory' || !type ? (
      <>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.title}
        >
          {`${translation?.['user-info']?.publications ?? 'Публикации'}:`}
        </Typography>
        <div className={classes.textWrap}>
          <Typography
            className={classes.text}
            variant="body2"
            color="textPrimary"
          >
            {`${locale === 'ru' ? 'Товары' : 'Goods'}: ${publications?.goods}`}
          </Typography>
        </div>
        <div className={classes.textWrap}>
          <Typography
            className={classes.text}
            variant="body2"
            color="textPrimary"
          >
            {`${translation?.['user-info']?.articles ?? 'Статьи'}: ${
              publications?.posts
            }`}
          </Typography>
        </div>
      </>
    ) : (
      <>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.title}
        >
          {`${translation?.['user-info']?.publications ?? 'Публикации'}:`}
        </Typography>
        <div className={classes.textWrap}>
          <Typography
            className={classes.text}
            variant="body2"
            color="textPrimary"
          >
            {`${translation?.['job-site']?.header?.adverts ?? 'Заказы'}: ${
              publications?.adverts
            }`}
          </Typography>
        </div>
        <div className={classes.textWrap}>
          <Typography
            className={classes.text}
            variant="body2"
            color="textPrimary"
          >
            {`${translation?.projects ?? 'Проекты'}: ${publications?.projects}`}
          </Typography>
        </div>
        <div className={classes.textWrap}>
          <Typography
            className={classes.text}
            variant="body2"
            color="textPrimary"
          >
            {`${translation?.models ?? 'Модели'}: ${publications?.models}`}
          </Typography>
        </div>
        <div className={classes.textWrap}>
          <Typography
            className={classes.text}
            variant="body2"
            color="textPrimary"
          >
            {`${translation?.['user-info']?.articles ?? 'Статьи'}: ${
              publications?.posts
            }`}
          </Typography>
        </div>
      </>
    )
  }

  return (
    <Card className={classes.card}>
      <CardContent>{renderPublications()}</CardContent>
    </Card>
  )
}
